import { makeAutoObservable } from "mobx";
import { workflowsLoader } from "src/business/workflow/apiWorkflow";
import { WorkflowsFilter, ZWorkflow } from "src/business/workflow/ZWorkflow";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { RtStore } from "src/components/ReactiveTable/RtStore";

import { createWorkflowColumns } from "./createWorkflowColumns";

export const workflowsPageStore = makeAutoObservable({
  table: new RtStore<ZWorkflow, WorkflowsFilter>({
    rowKey: "id",
    loader: workflowsLoader(),
  }),
  get columns(): RtColumn<ZWorkflow>[] {
    return createWorkflowColumns();
  },
});
